import { useEffect, useState } from "react";
import { LoadingSpinner } from "../../../../../_ePulse/layout/components/LoadingSpinner";
import { ToastMessageContainer } from "../../../../../_ePulse/layout/components/ToastMessageContainer";
import { CreateLabModal } from "./modals/createLabModel";
import useApi from "../../../../../hooks/useQuery";
import { GET_LAB_ROOM_LIST } from "../../GraphQLQueries/ProductOffering";
import { LabTable } from "./table/LabTable";

const Labs = () => {
  const [modalShow, setModalShow] = useState(0);
  const [labData, setLabData] = useState<any>(null);

  const {
    loading: loadingData,
    error: MedicineError,
    data: data,
    refetch: refetchList,
  } = useApi("", GET_LAB_ROOM_LIST, {
  })

  useEffect(() => {
    if (data  && data.getAllLabRooms ) {
      const newData = data.getAllLabRooms.map((data: any) => ({
        roomTypeId: data?.roomTypeId,
        roomName: data?.roomName,
        roomType: data?.roomType,
        labId: data?.id,
      }));
    setLabData(newData);
      console.log("newData", newData);
    }
    else {
      console.log("Error fetching lab data:");
    }
  }, [data])


  const handleModalClose = () => {
    setModalShow(0);
    refetchList();
  }

  return <div className='d-flex flex-column form-wrapper'>
    <LoadingSpinner isLoading={false} />
    <div>
      <ToastMessageContainer />

    </div>
    {modalShow === 1 && <CreateLabModal onClose={handleModalClose} />}

    <div className='d-flex justify-content-between align-items-center'>
      <h2 className='page-title'>Labs</h2>
      <button className='ePulse-btn-primary' onClick={() => setModalShow(1)}>
        Add Labs
      </button>

    </div>
    {labData &&  <LabTable data={labData} refetch={refetchList}/>}
  </div>;
};

export default Labs;